import { Skeleton } from '@//components/Skeleton';
import { VStack } from '@//components/VStack';
import styles from './Loan.module.scss';

const LoanSkeleton = () => (
  <VStack gap={32}>
    <Skeleton height="1.5rem" width="12.5rem" />
    <div className={styles.form}>
      <div className={styles.skeletonInput}>
        <Skeleton height="1.25rem" width="7.5rem" />
        <Skeleton height="3.125rem" width="100%" />
      </div>
      <div className={styles.skeletonInput}>
        <Skeleton height="1.25rem" width="7.5rem" />
        <div className={styles.skeletonGrid}>
          <Skeleton height="3.125rem" width="100%" />
          <Skeleton height="3.125rem" width="100%" />
          <Skeleton height="3.125rem" width="100%" />
          <Skeleton height="3.125rem" width="100%" />
          <Skeleton height="3.125rem" width="100%" />
        </div>
      </div>
      <div className={styles.skeletonInput}>
        <Skeleton height="1.25rem" width="7.5rem" />
        <Skeleton height="2.875rem" width="100%" />
      </div>
      <Skeleton height="2rem" width="100%" />
      <Skeleton height="9rem" width="100%" />
      <Skeleton height="2.5rem" width="9rem" className={styles.skeletonCenterButton} />
      <Skeleton height="6.5rem" width="100%" />
    </div>
  </VStack>
);

export default LoanSkeleton;
